module.exports = __webpack_public_path__ + "img/arrowhalf-bidirectional-horizontal.a7772c35.svg";